import { Provider } from "jotai";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry
import "../sentry.client.config";

// Development helpers for testing Sentry
if (import.meta.env.MODE === "development") {
  import("./utils/sentryUtils").then((sentryUtils) => {
    // Make Sentry test functions available globally in development
    interface WindowWithSentry extends Window {
      triggerTestError?: () => void;
      captureTestMessage?: () => void;
      triggerAsyncError?: () => Promise<void>;
      captureTestMessages?: () => void;
      setUserContext?: (
        userId: string,
        email?: string,
        username?: string
      ) => void;
      setAdditionalContext?: (
        key: string,
        value: Record<string, unknown>
      ) => void;
      setTag?: (key: string, value: string) => void;
    }

    const w = window as WindowWithSentry;
    w.triggerTestError = sentryUtils.triggerTestError;
    w.captureTestMessage = sentryUtils.captureTestMessage;
    w.triggerAsyncError = sentryUtils.triggerAsyncError;
    w.captureTestMessages = sentryUtils.captureTestMessages;
    w.setUserContext = sentryUtils.setUserContext;
    w.setAdditionalContext = sentryUtils.setAdditionalContext;
    w.setTag = sentryUtils.setTag;

    console.log("🚀 Sentry 테스트 함수들이 window 객체에 추가되었습니다!");
    // console.log("사용 가능한 함수들:");
    // console.log("• window.triggerTestError() - 직접 에러 캐치");
    // console.log("• window.triggerAsyncError() - 비동기 에러 테스트");
    // console.log("• window.captureTestMessage() - 단일 메시지 전송");
    // console.log("• window.captureTestMessages() - 다양한 레벨 메시지");
    // console.log(
    //   "• window.setUserContext(id, email, username) - 사용자 정보 설정"
    // );
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>
);
